import React from 'react';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import classNames from 'classnames/bind';
import styles from './ContentsWrap.module.scss';

const cx = classNames.bind(styles);

function ContentsWrap({ children }) {
	const ua = useSsrUserAgent();

	return <div className={cx(ua().isPc ? 'pc_container' : 'm_container')}>{children}</div>;
}

export default ContentsWrap;
